import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragHandle } from '../../icons/essentials/DragHandle';
import styles from './DraggableGrid.module.scss';
export const DraggableComponent = (param)=>{
    let { id, children, testIds, dragMode, itemHandleVisibility, itemHandleSize, itemDragActivation, itemHandlePosition, touchAction, minHeight, className, itemStyle, itemDropIndicator, itemDraggedAppearance, dropIndicator } = param;
    const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging: isThisItemDragging } = useSortable({
        id
    });
    // WHY: the ghost already follows the pointer, so translating the source item too would move the
    // layout out from under a drag the caller asked to keep still.
    const staysInPlace = dragMode === 'withGhost' && isThisItemDragging;
    const style = _object_spread_props(_object_spread({}, itemStyle), {
        transform: staysInPlace ? undefined : CSS.Transform.toString(transform),
        transition: staysInPlace ? undefined : transition,
        minHeight: minHeight ? "".concat(minHeight, "px") : undefined,
        touchAction
    });
    const fullItemListeners = itemDragActivation === 'full' ? listeners : {};
    const handleActivatorProps = itemDragActivation === 'handle' ? _object_spread({
        ref: setActivatorNodeRef
    }, listeners) : {};
    const handleVisibilityClass = itemHandleVisibility === 'hover' && !isThisItemDragging ? styles.handleHover : styles.handleAlways;
    const dragHandleElement = /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: "".concat(styles.dragHandle, " ").concat(handleVisibilityClass, " ").concat(itemHandleSize === 'small' ? styles.handleSmall : ''),
        "data-testid": testIds.dragHandle()
    }, handleActivatorProps), {
        children: /*#__PURE__*/ _jsx(DragHandle, {
            size: itemHandleSize === 'small' ? 14 : 20
        })
    }));
    const draggingClass = isThisItemDragging ? dragMode === 'withGhost' ? styles.draggingGhost : styles.draggingSolid : '';
    const edgeClass = itemDropIndicator === 'edge' && dropIndicator === 'before' ? styles.dropEdgeBefore : itemDropIndicator === 'edge' && dropIndicator === 'after' ? styles.dropEdgeAfter : '';
    const dimmedClass = itemDraggedAppearance === 'dimmed' && isThisItemDragging ? styles.dimmedWhileDragged : '';
    const itemClassName = [
        styles.sortableItem,
        draggingClass,
        edgeClass,
        dimmedClass,
        className
    ].filter(Boolean).join(' ');
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        ref: setNodeRef,
        "data-item-id": id,
        style: style,
        className: itemClassName
    }, attributes, fullItemListeners), {
        children: [
            itemHandlePosition === 'outside' && dragHandleElement,
            /*#__PURE__*/ _jsx("div", {
                className: styles.itemContent,
                "data-testid": testIds.item(),
                children: children({
                    dragHandle: itemHandlePosition === 'inside' ? dragHandleElement : undefined
                })
            })
        ]
    }));
};
